import { newE2EPage } from "@stencil/core/testing";
import { testValidHtmlElement } from "../../../../test-utils/html-validate";

describe("table-column-icon", () => {
    it("should match to snapshot with data", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-table>
            <uic-table-column-icon label="test" field="x" iconField="y"></uic-table-column-icon>
        </uic-table>`);
        const el = await page.find("uic-table");
        el.setProperty("data", [{ y: "icon1", x: "text1" }, { y: "icon2" }, { x: "text3" }, {}]);
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-table>
            <uic-table-column-icon label="test" field="x" iconField="y"></uic-table-column-icon>
        </uic-table>`);
        const el = await page.find("uic-table");
        el.setProperty("data", [{ y: "icon1", x: "text1" }]);
        await page.waitForChanges();
        await testValidHtmlElement(el);
    });
});
